import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { WatermarkDto } from '@nusign/picflow-backend-types';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ClickTrackDirective } from '../../../shared/directives/click-track.directive';
import { WatermarkUrlPipe } from '../../../shared/pipes/watermark-url.pipe';

@Component({
  selector: 'app-select-watermark-context',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonMenuItemComponent, SvgComponent, ClickTrackDirective, WatermarkUrlPipe],
  templateUrl: './select-watermark-context.component.html',
  styleUrl: './select-watermark-context.component.scss',
})
export class SelectWatermarkContextComponent {
  watermarks = input.required<WatermarkDto[]>();
  selectedWatermark = input.required<WatermarkDto>();
  tempSelectedWatermark = input.required<WatermarkDto>();
  selectWatermark = output<WatermarkDto>();
}
